<template>
    <nav aria-label="Breadcrumb">
    <ul class="breadcrumb" >          
        <li v-for="(crumb,kye) in crumbs " :key="kye" >
            <!--<template v-if="(kye > crumbLenth-2)">{{decodeHtmlLang(crumb.crumbText)}}</template>-->
            <router-link v-if="(kye > crumbLenth-2 && crumb.url !='/')" class="crumb-no-click" :to="crumb.url" v-html="crumb.crumbText" aria-current="page"></router-link>
            <router-link v-else :to="crumb.url" v-html="crumb.crumbText"></router-link>
            <!-- aria-current="page" -->
        </li>        
    </ul>
    </nav>
</template>
<script>
export default {
  name:'BreadCrumb',
  computed: {
    crumbs: function() {
      var module_id=""
      var division_id=""
      var element_id=""
      var category_id=""
      var breadcrumbArray=[];
      var from_page="";
     
      var home={'crumbText':this.$store.state.languageData['d00'], 'url':'/'}
      if(this.$route.meta.breadCrumb==='ModuleDivisionLevel'){
          breadcrumbArray.push(home)
          module_id=this.$route.params.module_id
          division_id=this.$route.params.division_id //if  undefined condition ned to add later

          breadcrumbArray.push({'crumbText':this.$store.state.languageData['d'+division_id], 'url':'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['m'+module_id], 'url':'#'})
          //console.log(breadcrumbArray)
      }
      else if(this.$route.meta.breadCrumb==='ModuleDivisionElementLevel'){
          breadcrumbArray.push(home)
          module_id=this.$route.params.module_id
          division_id=this.$route.params.division_id //if  undefined condition ned to add later
          element_id=this.$route.params.element_id //if  undefined condition ned to add later
          if(division_id)
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['d'+division_id], 'url':'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['m'+module_id], 'url':'/module/'+module_id+'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['e'+element_id], 'url':'#'})
          //console.log(breadcrumbArray)
      }
      else if(this.$route.meta.breadCrumb==='ModuleDivisionCategoryLevel'){
          breadcrumbArray.push(home)
          module_id=this.$route.params.module_id
          division_id=this.$route.params.division_id 
          category_id=this.$route.params.category_id
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['d'+division_id], 'url':'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['m'+module_id], 'url':'/module/'+module_id+'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['c'+category_id], 'url':'#'})
          //console.log(breadcrumbArray)
      }
      else if(this.$route.meta.breadCrumb==='ModuleDivisionCategoryElementLevel'){
          breadcrumbArray.push(home)
          module_id=this.$route.params.module_id
          division_id=this.$route.params.division_id 
          element_id=this.$route.params.element_id 
          category_id=this.$route.params.category_id
          if(division_id)
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['d'+division_id], 'url':'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['m'+module_id], 'url':'/module/'+module_id+'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['c'+category_id], 'url':'/module/'+module_id+'/category/'+category_id+'/division/'+division_id})
          breadcrumbArray.push({'crumbText':this.$store.state.languageData['e'+element_id], 'url':'#'})
          //console.log(breadcrumbArray)
      }
      else if(this.$route.meta.breadCrumb==='ContentRootLevel'){          
          module_id=this.$route.query.m
          division_id=this.$route.query.d 
          element_id=this.$route.query.e
          category_id=this.$route.query.c
          from_page=this.$route.query.from
          if(from_page!=='ht'){/*from htools page- mayo contents*/
          breadcrumbArray.push(home)
          if(division_id){
              breadcrumbArray.push({'crumbText':this.$store.state.languageData['d'+division_id], 'url':'/division/'+division_id})
            if(module_id){
              breadcrumbArray.push({'crumbText':this.$store.state.languageData['m'+module_id], 'url':'/module/'+module_id+'/division/'+division_id})

              if(category_id && !element_id)
                breadcrumbArray.push({'crumbText':this.$store.state.languageData['c'+category_id], 'url':'/module/'+module_id+'/category/'+category_id+'/division/'+division_id})
            
              if(element_id && !category_id)
                breadcrumbArray.push({'crumbText':this.$store.state.languageData['e'+element_id], 'url':'/module/'+module_id+'/element/'+element_id+'/division/'+division_id})
              
              
            if(category_id && element_id){
                breadcrumbArray.push({'crumbText':this.$store.state.languageData['c'+category_id], 'url':'/module/'+module_id+'/category/'+category_id+'/division/'+division_id})
                  breadcrumbArray.push({'crumbText':this.$store.state.languageData['e'+element_id], 'url':'/module/'+module_id+'/category/'+category_id+'/element/'+element_id+'/division/'+division_id})
                  
              }else{
                 // breadcrumbArray.push({'crumbText':'', 'url':'#'})
              }
            } 
              breadcrumbArray.push({'crumbText':'', 'url':'#'})
          }
          }
           
           
          //console.log(breadcrumbArray)
      }
      return breadcrumbArray;

//console.log(this.$route)

      // let pathArray = this.$route.path.split("/")
      // console.log('patharray',pathArray)
      // pathArray.shift()
      // let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
      //   breadcrumbArray.push({
      //     path: path,
      //     to: breadcrumbArray[idx - 1]
      //       ? "/" + breadcrumbArray[idx - 1].path + "/" + path
      //       : "/" + path,
      //     text: this.$route.matched[idx].meta.breadCrumb || path,
      //   });
      //   return breadcrumbArray;
      // }, [])
      // return breadcrumbs;
    },
    crumbLenth: function(){
      //var titleValue=this.decodeHtmlLang(this.crumbs[0].crumbText); 
      var titleValue="";
      for(var i=1;i<this.crumbs.length;i++){ 
        if(titleValue==""){
          titleValue=this.decodeHtmlLang(this.crumbs[i].crumbText);
        }
        else{
          titleValue=titleValue+' | '+ this.decodeHtmlLang(this.crumbs[i].crumbText);   
        }
               
      }
      //this.$announcer.set(titleValue);
      //alert(titleValue);
      document.title=titleValue;
      return this.crumbs.length;
    }
  }
};
</script>
<style scoped>
ul.breadcrumb {
    padding: 8px 8px;
    margin-bottom: 20px;
    list-style: none;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 14px;
    font-weight: normal !important;
}
/* ul.breadcrumb li+li:before {
  padding: 8px;
  color: black;
  content: "\00bb";
} */
ul.breadcrumb li+li:before {
  padding: 8px;
  color: white;
  content:" ";
  background-image: url(/img/double-arrow-right-icon.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 6px;
  padding: 0 12px;
}
.crumb-no-click{
  pointer-events: none;
  color:#454545;
}
a{
  color: #951905;
}
a:hover, a:active, a:focus {
  color: #751a0d;
}
</style>